import React from "react";
import styled from "styled-components";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import toast from "react-hot-toast";
import { QUERY_KEYS } from "constant/react_query";
import TopicForm from "components/common/topic/TopicForm/TopicForm";
import { TopicResult } from "common/topic/dto/TopicResult";
import TopicSingleNav from "components/common/topic/TopicSingleNav";
import { useTopicUpdate } from "hooks/asocijator/topic/useTopicUpdate";
import { topicFormDefaultValuesGet } from "common/topic/topic_form_common";
import { ItemTag } from "common/tag/dto/ItemTag";
import TopicTextChars from "components/common/topic/TopicTextChars";
import { isInputWayTextTopic } from "common/topic/topic_tag_common";
import { optionalFieldsEditGet } from "./TopicEdit.logic";

type TopicEditProps = {
  topic: TopicResult;
};

const TopicEdit = ({ topic }: TopicEditProps) => {
  const { handleSubmit, reset, control } = useForm({
    defaultValues: topicFormDefaultValuesGet(topic),
  });
  const { topicUpdateMutate } = useTopicUpdate({
    invalidateKeysArray: [
      [QUERY_KEYS.ASOCIJATOR_TOPIC_SEARCH],
      [QUERY_KEYS.ASOCIJATOR_TOPIC_GET],
    ],
  });
  const [tags, setTags] = React.useState<ItemTag[]>(topic.tags);
  const onTagsChange = React.useCallback((itemTags: ItemTag[]) => {
    setTags(itemTags);
  }, []);
  const isInputWayText = isInputWayTextTopic(topic);

  const onSubmit = async (data: any) => {
    console.log(data);

    const { name, description } = data;
    const optionalFields = optionalFieldsEditGet(data);
    topicUpdateMutate({
      id: topic.id,
      updatePayload: {
        name,
        description,
        tags,
        optionalFields,
      },
    });
    toast.success("Topic updated");
  };

  return (
    <DivTopic>
      <TopicForm
        control={control}
        onSubmit={onSubmit}
        handleSubmit={handleSubmit}
        reset={reset}
        defaultValues={topicFormDefaultValuesGet(topic)}
        onTagsChange={onTagsChange}
        isInputWayText={isInputWayText}
      />
      <DivNav>
        <TopicSingleNav topic={topic} hideEditNav={true} />
      </DivNav>
      {isInputWayText && (
        <DivNav>
          <TopicTextChars topic={topic} />
        </DivNav>
      )}
    </DivTopic>
  );
};

const DivTopic = styled.div`
  display: flex;
  flex-direction: column;
`;

const DivNav = styled.div`
  margin-top: 1rem;
`;

export default TopicEdit;
